import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { setPageTitle } from 'actions/header';
import { updateForm } from 'actions/templates';
import { addError } from 'actions/index';
import { addMeetingInstances, getMeeting, updateMeeting, deleteMeetingRelationship, deleteMeeting } from 'actions/meetings';
import { getMeetingTimeBlocks, deleteMeetingTimeBlock } from 'actions/timeblocks';
import swal from 'sweetalert2';
import Modal from 'containers/Modals/Modal';
import PostContent from 'components/Presentation/PostContent';
import ConnectForm from 'containers/Meeting/Form/ConnectForm';
import AddMeetingInstances from '../Form/AddMeetingInstances';
import BookMeeting from '../Form/BookMeeting';
import UpdateMeeting from '../Form/UpdateMeeting';
import CreateTimeBlocks from '../../TimeBlocks/CreateTimeBlocks';
import MeetingOccassions from './MeetingOccassions';
import { Spinner, Person } from 'UI';
import { Block, Flex, Icon, Button, Tabs, Tab } from '@haldor/ui';

var Meeting = /*#__PURE__*/function (_Component) {
  _inherits(Meeting, _Component);

  var _super = _createSuper(Meeting);

  function Meeting(props) {
    var _this;

    _classCallCheck(this, Meeting);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.meeting == null || _this.props.meeting != null && _this.props.meeting.id != _this.props.match.params.id) {
        _this.props.getMeeting(_this.props.match.params.id).then(function () {
          _this.props.setPageTitle(_this.props.meeting.title);

          _this.setState({
            lengthValue: _this.props.meeting.length ? _this.props.meeting.length : '',
            restLengthValue: _this.props.meeting.restLength ? _this.props.meeting.restLength : '',
            loading: false
          });
        })["catch"](function (err) {
          console.log(err);

          _this.setState({
            notFound: true
          });
        });

        _this.props.getMeetingTimeBlocks(_this.props.match.params.id);
      } else {
        _this.props.setPageTitle(_this.props.meeting.title);

        _this.setState({
          loading: false
        });

        _this.props.getMeeting(_this.props.match.params.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function () {
      _this.setState({
        modal: !_this.state.modal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleUpdateModal", function () {
      _this.setState({
        updateModal: !_this.state.updateModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAddMeetingInstances", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  values.instances.forEach(function (instance) {
                    instance.meetingId = _this.props.match.params.id;
                  });
                  _context.next = 3;
                  return _this.props.addMeetingInstances(_this.props.match.params.id, values.instances);

                case 3:
                  _this.setState({
                    loading: true
                  });

                  _context.next = 6;
                  return _this.props.getMeeting(_this.props.match.params.id);

                case 6:
                  _this.setState({
                    loading: false
                  });

                  _this.toggleModal();

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onUpdateMeeting", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  values.id = _this.props.match.params.id;
                  values.instances = _this.props.meeting.instances;

                  _this.setState({
                    loading: true
                  });

                  _context2.next = 5;
                  return _this.props.updateMeeting(values);

                case 5:
                  _context2.next = 7;
                  return _this.props.getMeeting(_this.props.match.params.id);

                case 7:
                  _this.setState({
                    loading: false
                  });

                  _this.toggleUpdateModal();

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onLockMeeting", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var values;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              values = _this.props.meeting;
              values.status = 'COMPLETED';
              swal.fire({
                title: _this.props.translate('are-you-sure'),
                text: _this.props.translate('meeting-lock-prompt'),
                showCancelButton: true,
                cancelButtonText: _this.props.translate('Cancel'),
                confirmButtonText: _this.props.translate('Yes')
              }).then( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(result) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(result.value != null)) {
                            _context3.next = 6;
                            break;
                          }

                          _this.setState({});

                          _context3.next = 4;
                          return _this.props.updateMeeting(values);

                        case 4:
                          _this.props.getMeeting(_this.props.match.params.id);

                          _this.props.addError(_this.props.translate('changes-saved'), 'info');

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "onUnlockMeeting", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var values;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              values = _this.props.meeting;
              values.status = 'ACTIVE';
              swal.fire({
                title: _this.props.translate('are-you-sure'),
                text: _this.props.translate('meeting-unlock-prompt'),
                showCancelButton: true,
                cancelButtonText: _this.props.translate('Cancel'),
                confirmButtonText: _this.props.translate('Yes')
              }).then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(result) {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!(result.value != null)) {
                            _context5.next = 6;
                            break;
                          }

                          _this.setState({});

                          _context5.next = 4;
                          return _this.props.updateMeeting(values);

                        case 4:
                          _this.props.getMeeting(_this.props.match.params.id);

                          _this.props.addError(_this.props.translate('changes-saved'), 'info');

                        case 6:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x4) {
                  return _ref6.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));

    _defineProperty(_assertThisInitialized(_this), "onPublishMeeting", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var values;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              values = _this.props.meeting;
              values.status = 'ACTIVE';

              _this.setState({});

              _context7.next = 5;
              return _this.props.updateMeeting(values);

            case 5:
              _this.props.getMeeting(_this.props.match.params.id);

              _this.props.addError(_this.props.translate('changes-saved'), 'info');

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    })));

    _defineProperty(_assertThisInitialized(_this), "toggleConnectForm", function () {
      var forceClose = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (forceClose == true) {
        _this.setState({
          connectForm: false,
          activeForm: null
        });
      } else {
        _this.setState({
          connectForm: !_this.state.connectForm,
          activeForm: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTimeBlocksModal", function (timeblock) {
      _this.setState({
        timeBlocksModal: !_this.state.timeBlocksModal,
        editTimeblock: timeblock
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConnectSubmit", function (submits) {
      return new Promise( /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resolve) {
          var tasks;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  tasks = [];
                  submits.forEach(function (form) {
                    if (form.id == null) {
                      // Add form to meeting
                      var meeting = _objectSpread({}, _this.props.meeting);

                      if (meeting.meetingForms == null) {
                        meeting.meetingForms = [];
                      }

                      meeting.meetingForms.push(form);

                      var task = _this.props.updateMeeting(meeting);

                      tasks.push(task);
                    }
                  });
                  Promise.all(tasks).then(function () {
                    _this.toggleConnectForm(true);

                    resolve(1);
                  });

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x5) {
          return _ref8.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onFormClick", function (form) {
      _this.setState({
        connectForm: true,
        activeForm: form.reference
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeTimeBlock", function (timeblock) {
      _this.props.deleteMeetingTimeBlock(_this.props.meeting.id, timeblock.id);
    });

    _defineProperty(_assertThisInitialized(_this), "getLengthDurations", function () {
      var times = [];
      var increment = 15;

      for (var i = 0; i < 8; i++) {
        if (i == 0) {
          times.push({
            text: increment + ' ' + _this.props.translate('minutes'),
            value: i + increment
          });
        } else {
          times.push({
            text: (i + 1) * increment + ' ' + _this.props.translate('minutes'),
            value: (i + 1) * increment
          });
        }
      }

      return times;
    });

    _defineProperty(_assertThisInitialized(_this), "getRestLength", function () {
      var times = [];
      var increment = 5;

      for (var i = 0; i < 13; i++) {
        if (i == 0) {
          times.push({
            text: i + ' ' + _this.props.translate('minutes'),
            value: i
          });
        } else {
          times.push({
            text: i * increment + ' ' + _this.props.translate('minutes'),
            value: i * increment
          });
        }
      }

      return times;
    });

    _defineProperty(_assertThisInitialized(_this), "setLengthDuration", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(event) {
        var meeting;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                meeting = _this.props.meeting;
                meeting.length = event.target.value;
                _context9.next = 4;
                return _this.props.updateMeeting(meeting);

              case 4:
                _this.props.addError(_this.props.translate('changes-saved'), 'info');

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      return function (_x6) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setRestDuration", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(event) {
        var meeting;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                meeting = _this.props.meeting;
                meeting.restLength = event.target.value;
                _context10.next = 4;
                return _this.props.updateMeeting(meeting);

              case 4:
                _this.props.addError(_this.props.translate('changes-saved'), 'info');

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x7) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleBooking", function (instance) {
      var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        bookingModal: !_this.state.bookingModal,
        bookingInstance: instance
      });

      if (reload) {
        _this.props.getMeeting(_this.props.meeting.id).then(function () {
          _this.props.setPageTitle(_this.props.meeting.title);

          _this.setState({
            lengthValue: _this.props.meeting.length ? _this.props.meeting.length : '',
            restLengthValue: _this.props.meeting.restLength ? _this.props.meeting.restLength : '',
            loading: false
          });
        })["catch"](function (err) {
          console.log(err);

          _this.setState({
            notFound: true
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingProgress", function (meeting) {
      var width = 0;

      if (meeting.totalMeetings != 0 && meeting.meetingsCompleted != 0) {
        width = meeting.meetingsCompleted / meeting.totalMeetings * 100;
      }

      return meeting.totalMeetings != null && meeting.meetingsCompleted != null ? /*#__PURE__*/React.createElement("div", {
        className: "size-14 color--meta"
      }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, _this.props.translate('completed-meeting')), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          textAlign: 'right'
        }
      }, meeting.meetingsCompleted, " / ", meeting.totalMeetings)), /*#__PURE__*/React.createElement("div", {
        className: "meeting-progress-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "indicator",
        style: {
          width: "".concat(width, "%")
        }
      }))) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMeetingInstance", function (instance) {
      var meeting = _this.props.meeting;
      return /*#__PURE__*/React.createElement(Link, {
        className: "meeting-participant",
        style: {
          marginTop: '1rem',
          display: 'flex',
          alignItems: 'center'
        },
        to: "/meeting/".concat(meeting.id, "/instance/").concat(instance.id),
        key: instance.id
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Person, {
        person: instance.student
      })), instance.date != null ? /*#__PURE__*/React.createElement("span", {
        className: "color--meta size-12"
      }, new DateTime(instance.date).getLongDateWithTime()) : null, instance.status == "COMPLETED" ? /*#__PURE__*/React.createElement("span", {
        className: "new-badge",
        style: {
          marginLeft: '.5rem'
        }
      }, _this.props.translate('complete-meeting')) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "deleteForm", function (form) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(result) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    _this.props.deleteMeetingRelationship(_this.props.meeting.id, form.id).then(function () {
                      _this.props.getMeeting(_this.props.match.params.id).then(function () {
                        _this.setState({
                          loading: false
                        });
                      });

                      _this.props.addError(_this.props.translate('changes-saved'), 'info');
                    });
                  }

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x8) {
          return _ref11.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveMeeting", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(result) {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    _this.props.deleteMeeting(_this.props.meeting.id).then(function () {
                      _this.props.history.push('/meetings');
                    });
                  }

                case 1:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        }));

        return function (_x9) {
          return _ref12.apply(this, arguments);
        };
      }());
    });

    _this.state = {
      loading: true,
      modal: false,
      updateModal: false,
      connectForm: false,
      activeForm: null,
      status: null,
      timeBlocksModal: false,
      lengthValue: 0,
      restLengthValue: 0,
      bookingInstance: null,
      bookingModal: false
    };
    return _this;
  }
  /* Helpers */


  _createClass(Meeting, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Lifecycle methods */

  }, {
    key: "renderAudience",
    value: function renderAudience(audience) {
      if (audience == "STUDENT") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-students'));
      } else if (audience == "GUARDIAN") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-guardians'));
      } else if (audience == "SELF") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('assigned-to-me'));
      } else if (audience == "FOLLOWUP") {
        return /*#__PURE__*/React.createElement("span", null, this.props.translate('follow-up'));
      } else {
        return /*#__PURE__*/React.createElement("span", null);
      }
    }
  }, {
    key: "getForms",
    value: function getForms() {
      var _this2 = this;

      var forms = [];

      if (this.props.meeting.relationships != null) {
        this.props.meeting.relationships.forEach(function (form) {
          if (form.referenceType == 'FORM') {
            _this2.props.meeting.instances.forEach(function (instance) {
              instance.relationships.forEach(function (relationship) {
                if (relationship.referenceType == "FORMINSTANCE") {
                  if (relationship.reference.formID == form.referenceID) {
                    form.answeredBy = form.answeredBy != null ? form.answeredBy++ : 1;
                  }
                }
              });
            });

            forms.push(form);
          }
        });
      }

      return forms;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.state.loading && !this.state.notFound) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      } else if (this.state.notFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('not-found')));
      }

      var user = new User(this.props.user);
      var _this$props = this.props,
          meeting = _this$props.meeting,
          translate = _this$props.translate;
      var forms = this.getForms();
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task meeting"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.connectForm,
        onClose: this.toggleConnectForm,
        title: translate('add-form')
      }, /*#__PURE__*/React.createElement(ConnectForm, {
        onSubmit: this.onConnectSubmit,
        initialValues: this.state.activeForm,
        meetingInstances: meeting.instances,
        onClose: this.toggleConnectForm
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modal,
        onClose: function onClose() {
          return _this3.toggleModal();
        },
        title: translate('meetings')
      }, /*#__PURE__*/React.createElement(AddMeetingInstances, {
        onSubmit: this.onAddMeetingInstances,
        onAbort: this.toggleModal,
        instances: meeting.instances
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.updateModal,
        onClose: function onClose() {
          return _this3.toggleUpdateModal();
        },
        title: translate('meetings')
      }, /*#__PURE__*/React.createElement(UpdateMeeting, {
        onSubmit: this.onUpdateMeeting,
        onAbort: this.updateModal
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.timeBlocksModal,
        onClose: function onClose() {
          return _this3.toggleTimeBlocksModal();
        },
        title: this.props.translate('meeting-time')
      }, /*#__PURE__*/React.createElement(CreateTimeBlocks, {
        onClose: this.toggleTimeBlocksModal,
        reference: meeting,
        timeblock: this.state.editTimeblock
      })), /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        isOpen: this.state.bookingModal,
        onClose: function onClose(instance, reload) {
          return _this3.toggleBooking(instance, reload);
        },
        title: this.props.translate('book-meeting-time')
      }, /*#__PURE__*/React.createElement(BookMeeting, {
        onClose: function onClose(instance, reload) {
          _this3.toggleBooking(instance, reload);
        },
        meeting: this.props.meeting,
        instance: this.state.bookingInstance
      })), /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('meeting-information'),
        route: "info"
      }, /*#__PURE__*/React.createElement(Block, null, meeting != null && meeting.status == "DRAFT" ? /*#__PURE__*/React.createElement("span", {
        className: "new-badge",
        style: {
          marginLeft: '15px'
        }
      }, " ", translate('Draft')) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('Information-to-participants')), /*#__PURE__*/React.createElement("div", {
        className: "size-14"
      }, /*#__PURE__*/React.createElement(PostContent, null, meeting.description))), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('students')), /*#__PURE__*/React.createElement("div", null, this.renderMeetingProgress(meeting))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, this.props.meeting.instances.map(function (instance, index) {
        return _this3.renderMeetingInstance(instance, index);
      })), user.data.id == meeting.creator && meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this3.toggleModal();
        },
        type: "secondary",
        style: {
          marginLeft: 0,
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('add-meeting')))) : null) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "forms"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          flex: 1
        }
      }, translate('forms')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), forms != null ? forms.map(function (form) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form",
          key: 'form-' + form.referenceID
        }, /*#__PURE__*/React.createElement("div", {
          className: "form-title"
        }, /*#__PURE__*/React.createElement("div", null, form.reference.title), form.answeredBy == null && user.data.id == meeting.creator ? /*#__PURE__*/React.createElement("div", {
          onClick: function onClick() {
            _this3.deleteForm(form);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Bin"
        })) : null), /*#__PURE__*/React.createElement("div", {
          className: "size-14"
        }, _this3.renderAudience(form.targetedAudience)));
      }) : null, forms != null && forms.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.25rem'
        }
      }, this.props.translate('no-form')) : null, !user.isStudent() && user.data.id == meeting.creator && meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.toggleConnectForm
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('add-form')) : null)) : null), !user.isStudent() && user.data.id == meeting.creator ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('booking-management'),
        route: "occasions"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement(MeetingOccassions, {
        meeting: this.props.meeting,
        location: this.props.location
      }))) : null)), !user.isStudent() && user.data.id == meeting.creator ? /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), meeting.status == 'COMPLETED' && user.isMentor() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onUnlockMeeting,
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Lock"
      }), " ", this.props.translate('unlock'))) : null, meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          _this3.toggleUpdateModal();
        },
        type: "secondary"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen"
      }), " ", this.props.translate('Edit'))) : null, meeting.status == 'DRAFT' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onRemoveMeeting,
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", this.props.translate('Delete'))) : null, meeting.status == 'DRAFT' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onPublishMeeting,
        style: {
          marginTop: 5
        },
        className: "c--button primary publishButton"
      }, this.props.translate('publish'))) : null, meeting.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.onLockMeeting,
        style: {
          marginLeft: 0,
          marginTop: 5
        },
        type: "secondary"
      }, this.props.translate('lock-and-archive'))) : null)) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    }
  }]);

  return Meeting;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    meeting: state.Meetings.meeting,
    user: state.user.currentUser,
    meetingTimeBlocks: state.TimeBlocks.meetingTimeBlocks,
    languages: state.Languages.languages
  };
}

export default withRouter(connect(mapStateToProps, {
  getMeeting: getMeeting,
  setPageTitle: setPageTitle,
  updateMeeting: updateMeeting,
  addMeetingInstances: addMeetingInstances,
  updateForm: updateForm,
  addError: addError,
  getMeetingTimeBlocks: getMeetingTimeBlocks,
  deleteMeetingTimeBlock: deleteMeetingTimeBlock,
  deleteMeetingRelationship: deleteMeetingRelationship,
  deleteMeeting: deleteMeeting
})(Meeting));